import _ from 'lodash';
import {toBytes} from 'utils';

export const DiskTypePriorities = {
    'network-ssd': 3,
    'network-hdd': 2,
    'local-ssd': 1,
};

export enum ClusterType {
    MYSQL = 'mysql',
    REDIS = 'redis',
    POSTGRESQL = 'postgresql',
    CLICKHOUSE = 'clickhouse',
    MONGODB = 'mongodb',
    DATA_NODE = 'elasticsearch',
}

export const HOST_DEFAULT_TYPES: Record<ClusterType, string> = {
    [ClusterType.MYSQL]: '',
    [ClusterType.REDIS]: '',
    [ClusterType.POSTGRESQL]: '',
    [ClusterType.CLICKHOUSE]: 'CLICKHOUSE',
    [ClusterType.MONGODB]: 'MONGOD',
    [ClusterType.DATA_NODE]: 'DATA_NODE',
};

export const ZOOKEEPER = 'ZOOKEEPER';

export const ZOOKEEPER_HOSTS_COUNT = 3;

export const HOST_TYPES = {
    BURSTABLE: 'burstable',
    HIGH_MEMORY: 'high-memory',
    STANDARD: 'standard',
    MEMORY_OPTIMIZED: 'memory-optimized',
};

export const PLATFORMS = {
    BROADWELL: '1',
    CASCADE_LAKE: '2',
};

export const DISK_TYPES = {
    NETWORK_SSD: 'network-ssd',
    NETWORK_HDD: 'network-hdd',
    LOCAL_SSD: 'local-ssd',
};

export const getPlatformOptions = _.memoize((i18n) => [
    {content: i18n('calculator', 'value_mdb-broadwell'), value: PLATFORMS.BROADWELL},
    {content: i18n('calculator', 'value_mdb-cascade-lake'), value: PLATFORMS.CASCADE_LAKE},
]);

export const getHostTypeOptions = _.memoize((i18n) => [
    {content: i18n('calculator', 'value_mdb-high-memory'), value: HOST_TYPES.HIGH_MEMORY},
    {content: i18n('calculator', 'value_mdb-memory-optimized'), value: HOST_TYPES.MEMORY_OPTIMIZED},
    {content: i18n('calculator', 'value_mdb-standard'), value: HOST_TYPES.STANDARD},
    {content: i18n('calculator', 'value_mdb-burstable'), value: HOST_TYPES.BURSTABLE},
]);

export const getDiskTypeOptions = _.memoize((i18n) => [
    {content: i18n('calculator', 'value_mdb-network-ssd'), value: DISK_TYPES.NETWORK_SSD},
    {content: i18n('calculator', 'value_network-hdd'), value: DISK_TYPES.NETWORK_HDD},
    {content: i18n('calculator', 'value_mdb-local-ssd'), value: DISK_TYPES.LOCAL_SSD},
]);

export const getRedisMemoryOptions = _.memoize((i18n) => [
    {content: i18n('calculator', 'value_mdb-network-ssd'), value: 2},
    {content: i18n('calculator', 'value_network-hdd'), value: 4},
]);

export const DISK_SIZE_STEP = toBytes(1, 'gb');
